import { createAction, props } from '@ngrx/store';
import { IProductUpdateRequest } from '../models/products.model';

export const updateProductRequest = createAction(
  '[UpdateProduct] Update Product Request',
  props<{ customerId: string; productSavingsId: string; request: IProductUpdateRequest }>()
);

export const updateProductSuccess = createAction('[UpdateProduct] Update Product Success', props<{ response: string }>());

export const updateProductFailure = createAction('[UpdateProduct] Update Product Failure', props<{ error: Error | any }>());
